import React, { useEffect, useState } from 'react';
import styles from './statistics-page.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import PopupStatistics from '../../components/PopupStatistics/PopupStatistics';
import { useDispatch, useSelector } from 'react-redux';
import { addStatisticsRedux } from '../../store/slices/showPopupStatisticsSlice';
import { bodyScrollOverflowHidden } from '../../helper';
import { getMeasurementsDb } from '../../firebase';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import { addMeasurementsRedux } from '../../store/slices/measurementsSlice';
import MeasurementsAllClients from '../../components/MeasurementsAllClients/MeasurementsAllClients';

export default function StatisticsPage() {
  let { group_id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loaderPage, setLoaderPage] = useState(false);
  const [showResultGroup, setShowResultGroup] = useState(false);

  const clientsMeasurements = useSelector((state) => state.measurements.measurements);

  useEffect(() => {
    const getMeasurements = async () => {
      setLoaderPage(true);
      const measurements = await getMeasurementsDb();

      dispatch(addMeasurementsRedux(measurements));
      setLoaderPage(false);
    };
    getMeasurements();
  }, []);

  // Підраховує статистику і повертає масив з результатами
  const calculationStatistics = (items) => {
    let calculationResult = [];

    if (items.length > 1) {
      for (let index = 0; index < items.length; index++) {
        if (items[index + 1]) {
          const kg =
            items[index].kg !== '' && items[index + 1].kg !== ''
              ? items[index].kg - items[index + 1].kg
              : '-';
          const totalVolume = items[index].totalVolume - items[index + 1].totalVolume;

          const itemObject = {
            id: items[index].id,
            kg: Number.isInteger(kg) ? kg : kg !== '-' ? kg.toFixed(1) : '-',
            totalVolume: Number.isInteger(totalVolume) ? totalVolume : totalVolume.toFixed(1),
          };

          // Якщо число ціле то залишає це число якщо ні то округляє до десятка
          calculationResult.push(itemObject);
        }
      }
    }

    return calculationResult;
  };

  // рендерить результати замірів
  const renderMeasurements = (itemsProps) => {
    // const items = itemsProps;
    const items = [...itemsProps].reverse();

    return items.map((item) => {
      return (
        <div key={item.id} className={styles.measurements_wrapper}>
          <div
            className={
              item.kg >= 0
                ? styles.measurement_value
                : item.kg !== '-'
                ? styles.measurement_value + ' ' + styles.statistics_unsatisfactory
                : styles.measurement_value + ' ' + styles.statistics_nan
            }>
            {item.kg >= 0
              ? '-' + item.kg + ' кг'
              : item.kg !== '-'
              ? '+' + Math.abs(item.kg) + ' кг'
              : '-'}
          </div>
          <div
            className={
              item.totalVolume >= 0
                ? styles.measurement_value
                : item.totalVolume !== 'NaN'
                ? styles.measurement_value + ' ' + styles.statistics_unsatisfactory
                : styles.measurement_value + ' ' + styles.statistics_nan
            }>
            {item.totalVolume >= 0
              ? '-' + item.totalVolume + ' см'
              : item.totalVolume !== 'NaN'
              ? '+' + Math.abs(item.totalVolume) + ' см'
              : '-'}
          </div>
        </div>
      );
    });
  };

  // Від першого заміра віднімає останій замір і рендерить результат
  const renderCalculationAllMeasurements = (items) => {
    const kg = items[0].kg - items[items.length - 1].kg;
    const measurements = items[0].totalVolume - items[items.length - 1].totalVolume;

    const kgValue =
      (kg !== 'NuN') & Number.isInteger(Number(kg.toFixed(1)))
        ? Number(kg.toFixed(1))
        : kg.toFixed(1);
    const measurementsValue =
      (measurements !== 'NuN') & Number.isInteger(Number(measurements.toFixed(1)))
        ? Number(measurements.toFixed(1))
        : measurements.toFixed(1);

    return (
      <div className={styles.statistics_conclusion_wrapper}>
        <div
          className={
            kgValue >= 0
              ? styles.statistics_conclusion_kg
              : kgValue !== 'NaN'
              ? styles.statistics_conclusion_kg + ' ' + styles.statistics_unsatisfactory
              : styles.statistics_conclusion_kg + ' ' + styles.statistics_nan
          }>
          {kgValue >= 0
            ? '-' + kgValue + ' кг'
            : kgValue !== 'NaN'
            ? '+' + Math.abs(kgValue) + ' кг'
            : '-'}
        </div>
        <div
          className={
            measurementsValue >= 0
              ? styles.statistics_conclusion_measurements
              : measurementsValue !== 'NaN'
              ? styles.statistics_conclusion_measurements + ' ' + styles.statistics_unsatisfactory
              : styles.statistics_conclusion_measurements + ' ' + styles.statistics_nan
          }>
          {measurementsValue >= 0
            ? '-' + measurementsValue + ' см'
            : measurementsValue !== 'NaN'
            ? '+' + Math.abs(measurementsValue) + ' см'
            : '-'}
        </div>
      </div>
    );
  };

  // Рендерить замір (це перший замір )
  const renderOneMeasurements = (items) => {
    return (
      <div className={styles.oneMeasurements_wrapper}>
        <div className={styles.oneMeasurements_item}>Вага {items[0].kg} кг</div>
        <div className={styles.oneMeasurements_item}>Об'єм {items[0].totalVolume} см</div>
      </div>
    );
  };

  const showStatistic = (item) => {
    // setShowPopup(true);

    if (item.measurements.length) {
      dispatch(addStatisticsRedux(item));
      bodyScrollOverflowHidden();
    }
  };

  // Відбрирає статистику групи в якій находимось
  const getGroupMeasurements = (measurements, group_id) => {
    // const groupMeasurements = measurements.filter((item) => {
    //   return item.group_id === group_id;
    // });
    // return groupMeasurements;

    for (let index = 0; index < measurements.length; index++) {
      const item = measurements[index];
      if (item.group_id === group_id) {
        return measurements;
      }
    }

    return [];
  };

  // Рендерить структури замірів
  const renderClient = (clientsMeasurements) => {
    let countClient = 0;
    return clientsMeasurements.map((item, index) => {
      // Відбирає заміри цієї групи
      const measurements = getGroupMeasurements(item.measurements, group_id);

      measurements.length && countClient++;
      return measurements.length ? (
        <div
          key={item.client_id}
          onClick={() => showStatistic(item)}
          className={
            item.measurements.length > 0
              ? styles.statistics_item + ' ' + styles.statistics_item_active
              : styles.statistics_item
          }>
          <div className={styles.statistics_client_name}>
            <span className={styles.statistics_client_name_number}>{countClient})</span>{' '}
            {item.fullName}
          </div>
          {measurements.length > 2 && renderCalculationAllMeasurements(measurements)}
          {measurements.length > 0 ? (
            measurements.length === 1 ? (
              renderOneMeasurements(measurements)
            ) : (
              renderMeasurements(calculationStatistics(measurements))
            )
          ) : (
            <div>Пусто:)</div>
          )}
        </div>
      ) : null;
    });
  };

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <div className={styles.header_wrapper}>
        <div className={styles.header_back_btn} onClick={() => navigate(-1)}>
          <svg
            width="12"
            height="18"
            viewBox="0 0 12 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M0 8.99999L11.25 0.339737V17.6602L0 8.99999Z" fill="white" />
          </svg>
          Назад
        </div>
        <div className={styles.header_title}>Статистика</div>
      </div>
      {/* -------------- /Header ------------------------ */}

      {loaderPage ? (
        <LoaderPage />
      ) : (
        <>
          <div className={styles.content_wrapper}>{renderClient(clientsMeasurements)}</div>

          {/* ------ Рендерить Cередній результат зміни ваги і замірів за весь час*/}
          <button
            className={styles.calculate_result_btn}
            onClick={() => setShowResultGroup(!showResultGroup)}>
            {showResultGroup ? 'Сховати' : 'Розрахувати середній результат'}
          </button>
          {showResultGroup && MeasurementsAllClients(clientsMeasurements, group_id)}
          {/* ------ /Рендерить Cередній результат зміни ваги і замірів за весь час */}

          <PopupStatistics />
        </>
      )}
    </>
  );
}
